import type { Column } from "@tanstack/react-table";
import { ChevronRight } from "lucide-react";

import { cn } from "@/lib/utils";

interface DataTableFilterCategoriesProps<TData, TValue> {
  columns: Column<TData, TValue>[];
  activeCategory: string | null;
  onCategoryChange: (categoryId: string) => void;
}

export function DataTableFilterCategories<TData, TValue>({
  columns,
  activeCategory,
  onCategoryChange,
}: DataTableFilterCategoriesProps<TData, TValue>) {
  return (
    <div className="w-[180px] rounded-l-md border-r border-border bg-background p-2">
      <div className="flex flex-col">
        {columns.map((column) => {
          const isActive = activeCategory === column.id;
          const displayName = column.columnDef.meta?.displayName ?? column.id;

          return (
            <button
              key={column.id}
              type="button"
              className={cn(
                "flex w-full items-center justify-between rounded px-2 py-1.5 text-left text-sm font-medium transition-colors",
                isActive
                  ? "bg-accent text-accent-foreground"
                  : "text-foreground hover:bg-accent hover:text-accent-foreground",
              )}
              onClick={() => {
                onCategoryChange(column.id);
              }}
            >
              <span className="capitalize">{displayName}</span>
              <ChevronRight className="size-4 text-muted-foreground" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
